export default {"src":"/_next/static/media/iop.19b40ecc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};